import { psAxios } from '@patsnap/common-ps-http';

function transformResponse(res: any) {
    if(res && res.config && res.headers && res.status && res.data) {
        return res.data;
    }
    return res;
}

// 添加试用
export function addTrialApi(_empower_type: string, _from?: string, data?: Record<string, any>) {
    return psAxios.post(
        `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka/account-privilege/add-trial`,
        data,
    ).then(res => transformResponse(res));
}

export function needAddTrialApi(data?: Record<string, any>) {
    return psAxios.post(
        `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka/account-privilege/product-onboarding/check`,
        data,
    ).then(res => transformResponse(res));
}
